import {type ISavedCart} from '../schema';

export const canRenameSavedCart = (savedCart?: Pick<ISavedCart, 'canManage'>) =>
	savedCart?.canManage === true;

export default canRenameSavedCart;
